// The featured piece shown on the hero card.
//
// Hand-edited — unlike heroImage.js, the script never touches this file.
// Everything here is a public claim about a real product, so keep it true:
// the garment type, the actual fabric, the actual work on it.

export const HERO_CARD = {
  // TODO: replace with the studio's own name for this piece.
  title: 'Powder-Mint Anarkali',

  // Shown as the small kicker above the title. Not 'Masterpiece' — a
  // superlative you award yourself is worth nothing, and the photograph is
  // already doing the work.
  kicker: 'Featured piece',

  // Category pill, top left.
  badge: 'Aari & Zardosi Handcraft',

  // Materials line. Describe what the piece is actually made of — the previous
  // copy claimed "Pure Raw Silk" over a georgette drape, which is a false
  // product claim, not a flourish.
  materials: 'Flowing Georgette • Gold Zari Cuffs',

  // Availability line, bottom right. No figures: this atelier quotes per piece.
  availability: 'Made to order',

  // Rating badge, top right. Set to null until these are real numbers from real
  // clients — an invented review count is the kind of thing that costs a studio
  // its credibility when someone asks to see the reviews.
  rating: null,
  // rating: { score: '5.0', count: 142 },
};

export default HERO_CARD;
